// @todo TO MERGE WITH guidedNavigation.js once both MRs are on master

import equal from 'fast-deep-equal';

export const shouldShowQuickFilters = (quickFilters, refinedItems) => {
    let currentFilters = [];
    const canShowQuickFilters =
        !!quickFilters &&
        Array.isArray(quickFilters.attributes) &&
        quickFilters.attributes.length > 0;

    if (canShowQuickFilters) {
        currentFilters = refinedItems.filter(
            item =>
                !['categories.l3.id', 'categories.l2.id'].includes(
                    item.attribute,
                ),
        );
    }

    return (
        canShowQuickFilters &&
        (currentFilters.length === 0 ||
            !currentFilters.every(item => {
                const attribute = quickFilters.attributes.find(
                    attributeItem => item.attribute === attributeItem.key,
                );
                if (!attribute) {
                    return false;
                }
                const compareValue =
                    item.currentRefinement instanceof Array
                        ? [attribute.value]
                        : attribute.value;
                return (
                    !!attribute && equal(compareValue, item.currentRefinement)
                );
            }))
    );
};

export const isQuickLink = quickFilter =>
    quickFilter.type === 'quick' &&
    typeof quickFilter.quickLink === 'string' &&
    quickFilter.quickLink.length > 0;

export default {
    shouldShowQuickFilters,
    isQuickLink,
};
